import React, { useEffect } from 'react';
import styles from "@/components/RightContent/index.less";
import {Badge} from "antd";
import {ClockCircleOutlined, DownloadOutlined} from "@ant-design/icons";
import {Link} from "umi";
import {useModel} from "@@/plugin-model/useModel";
import {DownloadCenter} from "@/services/basic/downloadcenter";

export const Download: React.FC = (props) => {
  const { initialState, setInitialState } = useModel('@@initialState');
  if (!initialState || !initialState.settings) {
    return null;
  }

  useEffect(() => {
    DownloadCenter.updateBudged(initialState, setInitialState);
    DownloadCenter.updateDownloadFile(initialState, setInitialState);
  }, [])

  return (
    <Link title="下载中心" className={styles.action} style={{ verticalAlign: 'middle' }} to='/basic/downloadcenter'>
      <Badge size="small"
             style={ initialState.fileUpdating ? {} : {backgroundColor: '#52c41a'}}
             count={initialState.fileUpdating ? <ClockCircleOutlined style={{ color: '#52c41a' }} /> : initialState.fileCounter}>
        <DownloadOutlined />
      </Badge>
    </Link>
  );
};

export default Download;
